import { GGOBaseComponent } from '../ggo.base.component.js';
export class AbstractModalContent extends GGOBaseComponent {
    enableAddButton(enabled = true) {
        this.dispatchEvent(new CustomEvent('enable-add-btn', {
            detail: { enabled: enabled },
            bubbles: true, // important pour que l'événement remonte au parent
            composed: true,
        }));
    }
    enableValidateButton(enabled = true) {
        this.dispatchEvent(new CustomEvent('enable-validate-btn', {
            detail: { enabled: enabled },
            bubbles: true, // important pour que l'événement remonte au parent
            composed: true,
        }));
    }
    setAutoClose(autoClose) {
        this.dispatchEvent(new CustomEvent('enable-auto-close', {
            detail: { autoClose },
            bubbles: true, // important pour que l'événement remonte au parent
            composed: true,
        }));
    }
}
